import { Program } from 'models';

export class ProgramSource {
  private programs: Program[];

  public constructor(programs: Program[]) {
    this.programs = programs;
  }

  public getPrograms(): Program[] {
    if (this.programs) {
      return this.programs;
    }
  }

  public getProgram(programName: string): Program {
    let selectedProgram: Program = {
      name: '',
      title: '',
      brand: '',
      features: [],
      img: '',
      lobs: [],
      network: '',
      posa: '',
      siteUrl: '',
      locale: '',
      signInLink: '',
      signUpLink: 'string',
      commissionPercentage: 0,
      cookieDurationDays: 0,
    };

    if (this.programs) {
      this.programs.map((program) => {
        if (program.name === programName) {
          selectedProgram = program;
        }
      });
    }

    return selectedProgram;
  }
}
